// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepRegisterPoliceman_modalOverlay__Vo6mP {
  background-color: rgba(25, 25, 25, 0.75);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
}

.StepRegisterPoliceman_headerContainer__KE7Mg {
  padding-top: 1rem;
  width: 100%;
  border-bottom: 1px solid rgba(82, 82, 82, 0.64);
}
.StepRegisterPoliceman_headerContainer__KE7Mg .StepRegisterPoliceman_titleContainer__HdjKk {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  padding-bottom: 0.7rem;
}
.StepRegisterPoliceman_headerContainer__KE7Mg .StepRegisterPoliceman_titleContainer__HdjKk img {
  cursor: pointer;
}
.StepRegisterPoliceman_headerContainer__KE7Mg > div {
  padding: 0 1.5rem;
}

.StepRegisterPoliceman_wrapper__LwQgr {
  display: flex;
  justify-content: space-between;
  flex: 1 1;
}

.StepRegisterPoliceman_container__lVlcU {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.StepRegisterPoliceman_container__lVlcU > div {
  height: 100%;
}

.StepRegisterPoliceman_footer__ilFzI {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(82, 82, 82, 0.64);
  width: 100%;
  height: 80px;
  padding: 1rem 1.5rem 1rem;
}
.StepRegisterPoliceman_footer__ilFzI > div {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.StepRegisterPoliceman_footer__ilFzI > div button:last-of-type {
  margin-left: 1rem;
}
.StepRegisterPoliceman_footer__ilFzI > div img {
  transform: rotate(180deg);
  color: black;
}
.StepRegisterPoliceman_footer__ilFzI button {
  background: var(--white);
  font-weight: 600;
  font-family: Inter;
  font-size: 0.9rem;
  padding: 0.65rem 1.5rem;
  border-radius: 4px;
  transition: background 0.3s;
}
.StepRegisterPoliceman_footer__ilFzI button.StepRegisterPoliceman_saveButton__z\\+4-A {
  background: var(--primary);
}
.StepRegisterPoliceman_footer__ilFzI button:disabled {
  background: var(--grey-200);
  color: var(--grey-300);
  cursor: default;
}

.StepRegisterPoliceman_loadingWrapper__i68mj {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.StepRegisterPoliceman_loadingWrapper__i68mj span {
  font-family: IBM Plex Sans;
  color: var(--grey-100);
}

.StepRegisterPoliceman_modalContent__IYzx7 {
  height: 72vh;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/StepRegister/StepRegisterPoliceman/StepRegisterPoliceman.module.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;EAEA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,YAAA;EACA,aAAA;EAEA,eAAA;AAFF;;AAKA;EAeE,iBAAA;EAEA,WAAA;EAEA,+CAAA;AAlBF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EAEA,iBAAA;EACA,sBAAA;AACJ;AACI;EACE,eAAA;AACN;AASE;EACE,iBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,8BAAA;EAEA,SAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EAEA,gBAAA;AAVF;AAYE;EACE,YAAA;AAVJ;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EAEA,4CAAA;EAEA,WAAA;EACA,YAAA;EAEA,yBAAA;AAdF;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAdJ;AAgBI;EACE,iBAAA;AAdN;AAiBI;EACE,yBAAA;EACA,YAAA;AAfN;AAmBE;EACE,wBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,uBAAA;EAEA,kBAAA;EAEA,2BAAA;AArBJ;AAuBI;EACE,0BAAA;AArBN;AAwBI;EACE,2BAAA;EACA,sBAAA;EACA,eAAA;AAtBN;;AA2BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,YAAA;AAzBF;AA2BE;EACE,0BAAA;EACA,sBAAA;AAzBJ;;AA6BA;EACE,YAAA;AA1BF","sourcesContent":[".modalOverlay {\n  background-color: rgba(25, 25, 25, 0.75);\n\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  width: 100vw;\n  height: 100vh;\n\n  position: fixed;\n}\n\n.headerContainer {\n  .titleContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    padding: 0 1.5rem;\n    padding-bottom: 0.7rem;\n\n    img {\n      cursor: pointer;\n    }\n  }\n\n  padding-top: 1rem;\n\n  width: 100%;\n\n  border-bottom: 1px solid rgba(82, 82, 82, 0.64);\n\n  > div {\n    padding: 0 1.5rem;\n  }\n}\n\n.wrapper {\n  display: flex;\n  justify-content: space-between;\n\n  flex: 1;\n}\n\n.container {\n  width: 100%;\n  height: 100%;\n\n  overflow-y: auto;\n\n  > div {\n    height: 100%;\n  }\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  border-top: 1px solid rgba(82, 82, 82, 0.64);\n\n  width: 100%;\n  height: 80px;\n\n  padding: 1rem 1.5rem 1rem;\n\n  > div {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    button:last-of-type {\n      margin-left: 1rem;\n    }\n\n    img {\n      transform: rotate(180deg);\n      color: black;\n    }\n  }\n\n  button {\n    background: var(--white);\n\n    font-weight: 600;\n    font-family: Inter;\n    font-size: 0.9rem;\n\n    padding: 0.65rem 1.5rem;\n\n    border-radius: 4px;\n\n    transition: background 0.3s;\n\n    &.saveButton {\n      background: var(--primary);\n    }\n\n    &:disabled {\n      background: var(--grey-200);\n      color: var(--grey-300);\n      cursor: default;\n    }\n  }\n}\n\n.loadingWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  height: 100%;\n\n  span {\n    font-family: IBM Plex Sans;\n    color: var(--grey-100);\n  }\n}\n\n.modalContent {\n  height: 72vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `StepRegisterPoliceman_modalOverlay__Vo6mP`,
	"headerContainer": `StepRegisterPoliceman_headerContainer__KE7Mg`,
	"titleContainer": `StepRegisterPoliceman_titleContainer__HdjKk`,
	"wrapper": `StepRegisterPoliceman_wrapper__LwQgr`,
	"container": `StepRegisterPoliceman_container__lVlcU`,
	"footer": `StepRegisterPoliceman_footer__ilFzI`,
	"saveButton": `StepRegisterPoliceman_saveButton__z+4-A`,
	"loadingWrapper": `StepRegisterPoliceman_loadingWrapper__i68mj`,
	"modalContent": `StepRegisterPoliceman_modalContent__IYzx7`
};
export default ___CSS_LOADER_EXPORT___;
